import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["input", "counter"];
  static values = { maxLength: Number };

  declare inputTarget: HTMLInputElement | HTMLTextAreaElement;
  declare counterTarget: HTMLElement;
  declare maxLengthValue: number;

  connect(): void {
    this.updateCounter();
  }

  updateCounter(): void {
    const currentLength = this.inputTarget.value.length;
    const maxLength =
      this.maxLengthValue ||
      parseInt(this.inputTarget.getAttribute("maxlength") || "0");
    this.counterTarget.textContent = `${currentLength}/${maxLength}`;
  }
}
